module.exports = __webpack_public_path__ + "img/CPTemp1.7529b1ba.png";